<template>
    <div>
        <el-collapse>
            <el-collapse-item>
                <template slot="title">
                    <i class="header-icon el-icon-s-operation"></i>筛选
                    <span class="totalwrp">总条数:{{ total }}</span>
                </template>
                <div class="dataFilterWrap">
                    <el-row :gutter="8">
                        <el-col :span="6">
                            <label for="">姓名: </label>
                            <el-input type="text" v-model="keyword" clearable></el-input>
                        </el-col>
                        <el-col :span="6">
                            <label for="">成绩: </label>
                            <el-select v-model="ispass" placeholder="请选择">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="通过" value="1"></el-option>
                                <el-option label="未通过" value="0"></el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="12">
                            <el-button type="default" @click="searchKeyWord">搜索</el-button>
                            <el-button style="margin-left: 16px;" type="success"
                                @click="addShow = true">新增学员</el-button>
                            <el-button style="margin-left: 16px;" type="primary"
                                @click="importShow = true">导入学员</el-button>
                            <el-button style="margin-left: 16px;" type="primary"
                                @click="importCaShow = true">导入证书</el-button>
                            <el-button style="margin-left: 16px;" type="primary" @click="piShow = true">管理批次</el-button>
                        </el-col>
                    </el-row>
                </div>
            </el-collapse-item>
        </el-collapse>
        <el-table :data="orders" stripe fit tooltip-effect="dark">
            <el-table-column label="ID" width="70">
                <template slot-scope="scope">{{ scope.row.Member_ID }}</template>
            </el-table-column>

            <el-table-column label="姓名" width="110">
                <template slot-scope="scope">{{
                    scope.row.Member_Name
                }}</template>
            </el-table-column>

            <el-table-column label="身份证" width="220">
                <template slot-scope="scope">{{
                    scope.row.Member_CertNo
                }}</template>
            </el-table-column>
            <el-table-column label="批次" width="70">
                <template slot-scope="scope">{{
                    scope.row.Member_Unit
                }}</template>
            </el-table-column>
            <el-table-column label="分数" width="70">
                <template slot-scope="scope">{{
                    scope.row.Member_Score
                }}</template>
            </el-table-column>
            <el-table-column label="证书编号" width="170">
                <template slot-scope="scope">{{
                    scope.row.Member_CANumber
                }}</template>
            </el-table-column>
            <el-table-column label="证书日期">
                <template slot-scope="scope">{{
                    scope.row.Member_CADate
                }}</template>
            </el-table-column>
            <el-table-column label="操作" width="270" fixed="right">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="showEditFun(scope.row)">修改</el-button>
                    <el-button type="warning" size="mini" @click="delone(scope.row)">删除</el-button>
                    <el-button type="default" size="mini" @click="showCaOne(scope.row)">添加证号</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next" :total="total" :current-page="pageindex"
            @current-change="setPageIndx">
        </el-pagination>

        <el-dialog title="修改" :visible.sync="editShow" modal width="37%" :close-on-click-modal="false">
            <el-row class="edit-info">
                <el-col :span="24">
                    <label>姓名</label>
                    <el-input type="text" v-model="currentOne.Member_Name"></el-input>
                </el-col>
                <el-col :span="24">
                    <label>身份证</label>
                    <el-input type="text" v-model="currentOne.Member_CertNo"></el-input>
                </el-col>
                <el-col :span="24">
                    <label>证书编号</label>
                    <el-input type="text" v-model="currentOne.Member_CANumber"></el-input>
                </el-col>
                <el-col :span="24">
                    <label>证书日期</label>
                    <div>
                        <el-date-picker style="width: 100%;" type="date" v-model="currentOne.Member_CADate"
                            value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                    </div>

                </el-col>
                <el-col :span="24">
                    <label>批次</label>
                    <el-input type="text" v-model="currentOne.Member_Unit"></el-input>
                </el-col>
                <el-col :span="24" style="text-align: center;">
                    <el-button type="primary" @click="sureToEdit">保存</el-button>
                </el-col>
            </el-row>
        </el-dialog>

        <el-dialog title="修改" :visible.sync="addShow" modal width="37%" :close-on-click-modal="false">
            <el-row class="edit-info">
                <el-col :span="24">
                    <label>姓名</label>
                    <el-input type="text" v-model="Member_Name"></el-input>
                </el-col>
                <el-col :span="24">
                    <label>身份证</label>
                    <el-input type="text" v-model="Member_CertNo"></el-input>
                </el-col>
                <el-col :span="24" style="text-align: center;">
                    <el-button type="primary" @click="sureToAdd">保存</el-button>
                </el-col>
            </el-row>
        </el-dialog>


        <el-dialog title="颁发证书" :visible.sync="addCaShow" modal width="37%" :close-on-click-modal="false">
            <el-row class="edit-info">
                <el-col :span="24">
                    <label>证书编号</label>
                    <el-input type="text" v-model="canumber"></el-input>
                </el-col>
                <el-col :span="24">
                    <label>证书日期</label>
                    <el-date-picker v-model="cadate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                        style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col :span="24" style="text-align: center;">
                    <el-button type="primary" @click="sureToAddCa">确定</el-button>
                </el-col>
            </el-row>
        </el-dialog>

        <el-dialog title="导入学员" :visible.sync="importShow" modal width="37%" :close-on-click-modal="false">
            <el-row class="edit-info">
                <el-col :span="24">
                    <label>模板文件</label>
                    <a class="download-file" target="_blank" download="true"
                        :href="domin + '/AdminAjax/travelperson.xlsx'">下载模板</a>
                </el-col>
                <el-col :span="24">
                    <label>选择文件</label>
                    <el-upload class="upload-btn" action="/Ajax/upload_json.ashx?dir=file" name="imgFile"
                        :on-success="UploadFile" :show-file-list="false">
                        <el-button type="default">上传文件</el-button>
                    </el-upload>
                </el-col>
                <el-col :span="24">
                    <label>文件地址</label> {{ formData.url }}
                </el-col>
                <el-col :span="24" style="text-align: center;">
                    <el-button type="primary" @click="sureToUpload">确定</el-button>
                </el-col>
            </el-row>
        </el-dialog>

        <el-dialog title="输入批次" :visible.sync="piShow" modal width="37%" :close-on-click-modal="false">
            <el-row class="edit-info">
                <el-col :span="24">
                    <label>批次</label>
                    <el-input type="text" v-model="pi" placeholder="请输入批次(数字)"></el-input>
                </el-col>
                <el-col :span="24" style="text-align: center;">
                    <el-button type="primary" @click="sureToPi">确定导出</el-button>
                    <el-button type="warning" @click="sureToDelPi">确定删除</el-button>
                </el-col>
            </el-row>
        </el-dialog>
        <el-dialog title="导入证书" :visible.sync="importCaShow" modal width="37%" :close-on-click-modal="false">
            <el-row class="edit-info">
                <el-col :span="24">
                    <label>模板文件</label>
                    <a class="download-file" target="_blank" download="true"
                        :href="domin + '/AdminAjax/travelpersonca.xlsx'">下载模板</a>
                </el-col>
                <el-col :span="24">
                    <label>选择文件</label>
                    <el-upload class="upload-btn" action="/Ajax/upload_json.ashx?dir=file" name="imgFile"
                        :on-success="UploadFile" :show-file-list="false">
                        <el-button type="default">上传文件</el-button>
                    </el-upload>
                </el-col>
                <el-col :span="24">
                    <label>文件地址</label> {{ formData.url }}
                </el-col>
                <el-col :span="24" style="text-align: center;">
                    <el-button type="primary" @click="sureToUploadCa">确定</el-button>
                </el-col>
            </el-row>
        </el-dialog>


    </div>
</template>

<script>
export default {
    data() {
        return {
            domin: this.glb.domin,
            orders: [],
            ispass: "",
            status: "",
            editShow: false,
            addShow: false,
            addCaShow: false,
            importShow: false,
            importCaShow: false,
            pageindex: 1,
            keyword: "",
            total: 0,
            name: "",
            uid: "",
            currentOne: {},
            canumber: "",
            cadate: "",
            Member_Name: "",
            Member_CertNo: "",
            formData: {},
            pi: "",
            piShow: false
        };
    },

    mounted() {
        this.pullList()
    },
    methods: {
        showEditFun(one) {
            // one.Member_CADate = new Date();
            if (!!one.Member_CADate) {
                one.Member_CADate = one.Member_CADate.slice(0, -1).replace(/[\u5E74\u6708\u65E5]/g, "-")
            }
            this.currentOne = { ...one };
            this.editShow = true;
            console.log("one:", one);
        },
        showCaOne(one) {
            this.currentOne = one;
            this.addCaShow = true;
        },
        delone(one) {
            this.$confirm("确定要删除吗？", "提示", {
                type: "warning",
            }).then(() => {
                this.ipost(
                    "/AdminAjax/Member.ashx?type=delete",
                    {
                        id: one.Member_ID,
                    },
                    (res) => {

                        this.pullList();
                        this.$message.success("删除成功");

                    }
                )
            })
        },
        UploadFile(res) {
            this.$set(this.formData, "url", res.url);
            console.log("res:", res);
        },
        sureToUpload() {
            this.ipost(
                "/AdminAjax/Member.ashx?type=import", {
                url: this.formData.url,
            },
                (res) => {
                    console.log("res:", res);
                    this.importShow = false;
                    this.$message.success("导入学员成功");
                    this.pullList();
                }
            );
        },
        sureToUploadCa() {
            this.ipost(
                "/AdminAjax/Member.ashx?type=importca", {
                url: this.formData.url,
            },
                (res) => {
                    console.log("res:", res);
                    this.importCaShow = false;
                    this.$message.success("导入证书成功");
                    this.pullList();
                }
            );
        },
        sureToPi() {
            this.ipost(
                "/AdminAjax/Member.ashx?type=exporttoexcel", {
                unit: this.pi,
            },
                (res) => {
                    window.open(this.domin + res.url);
                }
            );
        },
        sureToDelPi() {
            this.$confirm("确定要删除吗？", "提示", {
                type: "warning",
            }).then(() => {
                this.ipost(
                    "/AdminAjax/Member.ashx?type=deleteunit",
                    {
                        unit: this.pi,
                    },
                    (res) => {
                        console.log("res:", res);
                        this.$message.success("删除成功");
                        this.piShow = false;
                        this.pullList();
                    }
                )
            })

        },
        sureToEdit() {
            this.ipost(
                "/AdminAjax/Member.ashx?type=update",
                {
                    model: JSON.stringify(this.currentOne),
                },
                (res) => {
                    console.log("res:", res);
                    this.$message.success("修改成功");
                    this.editShow = false;
                    this.pullList();
                }
            )
        },
        sureToAdd() {
            this.ipost(
                "/AdminAjax/Member.ashx?type=insert",
                {
                    model: JSON.stringify({
                        Member_Name: this.Member_Name,
                        Member_CertNo: this.Member_CertNo,
                    }),
                },
                (res) => {
                    console.log("res:", res);
                    this.$message.success("添加成功");
                    this.addShow = false;
                    this.pullList();
                }
            )

        },
        searchKeyWord() {
            this.pageindex = 1;
            this.pullList();
        },


        setPageIndx(pgindx) {
            // console.log(e);
            this.pageindex = pgindx;
            this.pullList();
        },
        sureToAddCa() {
            if (!this.canumber) {
                this.$message.error("请输入证书编号");
                return;
            }
            if (!this.cadate) {
                this.$message.error("请选择证书日期");
                return;
            }
            this.ipost(
                "/AdminAjax/Member.ashx?type=issueca",
                {
                    id: this.currentOne.Member_ID,
                    canumber: this.canumber,
                    cadate: this.cadate,
                },
                (res) => {
                    // console.log("res:", res);
                    this.$message.success("颁发成功");
                    this.addCaShow = false;
                    this.pullList();
                })
        },
        pullList() {
            this.ipost(
                "/AdminAjax/Member.ashx?type=select", {
                keyword: this.keyword,
                ispass: this.ispass,
                pageindex: this.pageindex,
                pagesize: 10,
            },
                (res) => {
                    // console.log("res:", res);
                    this.orders = res.list;
                    this.total = res.count;
                }
            );
        },
    },
};
</script>

<style scoped>
.upload-btn {
    display: inline-block;
    margin-left: 12px;

}

.download-file {
    display: inline-block;
    padding: 6px 12px;
    background: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    font-size: 15px;
    margin-left: 12px;
}

.edit-info .el-col {
    margin-bottom: 12px;
    font-size: 16px;
}

.edit-info .el-col .el-input {
    font-size: 19px;
}

.dataFilterWrap .el-row .el-col {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.dataFilterWrap .el-row .el-col label {
    display: block;
    width: 80px;
    padding-right: 2px;
}

.dataFilterWrap button {
    margin-left: 10px;
}

.mark-wrp {
    text-align: center;
}

.mark-wrp .el-button {
    margin: 12px 6px;
}

.img-cert {
    width: 80px;
}

.el-table table {
    width: 100%;
}

.cell button,
.dialog-footer .el-button {
    margin: 0 8px;
}

.search-wrp .el-input {
    width: 60%;
    margin-right: 10px;
}

.el-collapse-item .el-row {
    padding: 6px 12px;
}

.el-pagination {
    margin: 16px auto;
    text-align: center;
}

.el-dialog .el-select {
    width: 100%;
}

.btns-wrp {
    text-align: center;
}

.couriers {
    list-style: none;
}

.couriers li {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #dedede;
    line-height: 2.2;
    padding: 12px;
}

.couriers li:hover {
    background-color: #fafafa;
    cursor: pointer;
}

.couriers li span {
    font-weight: bold;
}

.couriers li span:last-child {
    margin-left: 30px;
    color: #22a6f2;
    font-size: 16px;
}

.search-wrp-top .el-col {
    display: flex;
    justify-content: center;
    align-items: center;
}

.order-details .el-input,
.order-details .el-select {
    width: 90%;
}

.order-details button {
    display: block;
    height: 40px;
    width: 90%;
}

.order-details label {
    display: block;
    line-height: 3;
}

.details-btn {
    text-align: center;
    padding-top: 20px;
}
</style>
